import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Logo } from "@/components/customer/Logo";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bienvenido");
      navigate("/admin");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center px-5">
      <div className="absolute top-0 left-0 w-96 h-96 bg-indigo-600/20 rounded-full blur-3xl" />
      <div className="w-full max-w-sm relative">
        <div className="flex justify-center mb-8"><Logo dark size="lg" /></div>
        <form onSubmit={submit} className="bg-white rounded-2xl p-8 shadow-2xl" data-testid="admin-login-form">
          <div className="flex items-center gap-2 mb-6">
            <div className="h-10 w-10 rounded-xl bg-indigo-50 flex items-center justify-center"><Lock className="h-5 w-5 text-indigo-600" /></div>
            <div>
              <h1 className="font-heading font-bold text-lg text-slate-900">Panel administrativo</h1>
              <p className="text-xs text-slate-400">Acceso restringido</p>
            </div>
          </div>
          <div className="space-y-4">
            <div>
              <Label className="text-sm">Email</Label>
              <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="rounded-lg mt-1.5 h-11" placeholder="admin@email.com" data-testid="admin-email" required />
            </div>
            <div>
              <Label className="text-sm">Contraseña</Label>
              <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="rounded-lg mt-1.5 h-11" placeholder="••••••••" data-testid="admin-password" required />
            </div>
            <Button type="submit" disabled={loading} className="w-full rounded-lg h-11 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold" data-testid="admin-login-submit">
              {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Ingresar"}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
